import { z } from 'zod';
import { PUBLIC_URLS } from './public-urls.js';
/**
 * Terms of Service / Privacy Policy acceptance — the single source, in code (not DB rows).
 *
 * Bump `TERMS_VERSION` when the documents change materially; every signed-in user whose stored
 * `termsVersion` differs is then shown the "We've updated our Terms" interstitial once.
 *
 * The two URLs are interim marketing-site links; issue #149 tracks replacing them with the
 * platform's own documents.
 */
export const TERMS_VERSION = '2026-10-20';
export const TERMS_URL = PUBLIC_URLS.terms;
export const PRIVACY_URL = PUBLIC_URLS.privacy;
/**
 * `POST /api/web/auth/terms-acceptance` and `POST /api/web/partner/auth/terms-acceptance`.
 *
 * No version field: the server stamps ITS `TERMS_VERSION`, so a stale tab can never record an
 * older version than the one the user was shown last. The caller is whoever the verified token
 * says; nothing identifying comes from the body.
 */
export const acceptTermsRequestSchema = z.object({ acceptTerms: z.literal(true) });
export const termsAcceptanceDTOSchema = z.object({
    termsVersion: z.string().min(1),
    termsAcceptedAt: z.string().datetime(),
});
//# sourceMappingURL=terms.js.map